import { render, staticRenderFns } from "./Timeslots.vue?vue&type=template&id=117a1cf4&scoped=true&"
import script from "./Timeslots.vue?vue&type=script&lang=ts&"
export * from "./Timeslots.vue?vue&type=script&lang=ts&"
import style0 from "./Timeslots.vue?vue&type=style&index=0&id=117a1cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a1cf4",
  null
  
)

export default component.exports